import React from 'react';
import PropTypes from 'prop-types';
import DyzioModal from 'dyzio-shared-components/lib/components/dyzio-modal';
import { Grid, Image, Divider, List, Icon, Checkbox } from 'semantic-ui-react';
import _ from 'lodash';

const nameSpanStyle = {
  fontSize: 20,
  fontWeight: 600,
  width: '100%',
};

const AudienceDataRequestModal = ({
  onClose,
  influencer,
  onPlatformSelected,
  onSendADRRequestButtonClick,
}) => {
  const {
    name,
    thumbnail,
    primarySocialHandle,
    instagram,
    facebook,
    youtube,
    email,
  } = influencer;
  const channels = [
    { key: 'instagram', value: instagram },
    { key: 'youtube', value: youtube },
    { key: 'facebook', value: facebook },
  ];
  return (
    <DyzioModal
      headerText="Audience Data Request"
      onClose={onClose}
      size="small"
      hasActionButton
      actionButtonContent="Send"
      onActionButtonClick={onSendADRRequestButtonClick}
    >
      <span>
        Send an audience data request to your influencer. This will allow you to see their audience demographics
        on Instagram, Facebook and Youtube. (Twitter coming soon).
      </span>
      <Divider hidden />
      <Grid>
        <Grid.Row>
          <Grid.Column width={4} verticalAlign="middle">
            <h3>Influencer</h3>
          </Grid.Column>
          <Grid.Column width={12} verticalAlign="middle">
            <Image src={thumbnail} avatar size="tiny" />
            <span>
              <b style={nameSpanStyle}>{name}</b> @{primarySocialHandle}
            </span>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={4} verticalAlign="middle">
            <h3>Channels</h3>
          </Grid.Column>
          <Grid.Column width={12} verticalAlign="middle">
            <List>
              {
                _.map(channels, (channel =>
                  <List.Item>
                    <Grid verticalAlign="middle">
                      <Grid.Row>
                        <Grid.Column width={3}>
                          <Icon name={channel.key} size="large" />
                        </Grid.Column>
                        <Grid.Column width={6}>
                          { _.upperFirst(channel.value) }
                        </Grid.Column>
                        <Grid.Column width={3}>
                          <Checkbox toggle value={channel.key} name={channel.key} onChange={onPlatformSelected} />
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </List.Item>),
                )
              }
            </List>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={4} verticalAlign="middle">
            <h3>Email</h3>
          </Grid.Column>
          <Grid.Column width={12} verticalAlign="middle">
            {email}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </DyzioModal>
  );
};

AudienceDataRequestModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  influencer: PropTypes.object.isRequired,
  onPlatformSelected: PropTypes.func.isRequired,
  onSendADRRequestButtonClick: PropTypes.func.isRequired,
};

export default AudienceDataRequestModal;



/** WEBPACK FOOTER **
 ** ./src/components/audience-data-request-modal/index.js
 **/